<template>
	<div class="col-12">
		<div class="panel_header">
			<div class="row align-items-end">
				<div v-if="block.block_title" class="col-12">
					<h2>{{ block.block_title }}</h2>
				</div>
				<div v-if="block.subtitle" class="col-12">
					<p>{{ block.subtitle }}</p>
				</div>
			</div>
		</div>

		<div v-if="okSuccessMessage">
			<div>
				<div>
					<h4 class="title title-lg mb-4">
						{{ okSuccessMessage.title }}
					</h4>
					<div v-html="okSuccessMessage.value" />
				</div>
				<div
					v-if="okSuccessMessage.is_button_enabled == 1"
					class="p-4 w-lg-50"
				>
					<a :href="okSuccessMessage.button_link">
						<b-button variant="primary">
							{{ okSuccessMessage.button_text }}
						</b-button>
					</a>
				</div>
			</div>

			<FormulateInput
				type="button"
				@click="onClickAgainSubmit"
			>
				Отправить форму повторно
			</FormulateInput>
		</div>
		<div v-else>
			<FormulateForm
				v-if="mounted && autocompleted"
				v-model="formValues"
				:schema="schema"
				class="row"
				@submit="submit"
				@onChangeSwitchMiddleName="onChangeSwitchMiddleName"
				@setCompanyInfo="setCompanyInfo"
				@validatePhone="validatePhone"
			>
				<div
					v-if="(isAuthorized && block.authentication_required)
						|| !block.authentication_required"
					class="col-12"
				>
					<products-component v-model="products" :block="block" />

					<div v-html="block.footer_text" />

					<div v-if="block.show_amount">
						<p class="title">
							Стоимость: {{ amount }} руб
						</p>
					</div>

					<agreement-input class="mb-2" />
					<loyalty-registration-input />

					<FormulateInput
						type="submit"
						class="mt-3"
						:disabled="isLoadingSubmit"
					>
						<b-spinner
							v-if="isLoadingSubmit"
							style="margin-right: 15px; width: 1.3em; height: 1.3em;"
						/>
						{{ isLoadingSubmit ? 'Идет отправка формы...' : 'Отправить' }}
					</FormulateInput>
					<CookieError v-if="isErrorCookie" />
				</div>

				<div v-else>
					<div class="col-12 mb-3">
						Необходимо быть зарегистрированным в системе
					</div>
					<FormulateInput
						type="button"
						class="mb-0 col-12"
						:disabled="isLoadingSubmit"
						@click="showLoginPopup"
					>
						Авторизоваться
					</FormulateInput>
				</div>
			</FormulateForm>
		</div>
	</div>
</template>

<script>
import formulateFormScenario from '~/mixins/formulateFormScenario';
import ProductsComponent from '~/components/panels/formulate/products/ProductsComponent.vue';
import AgreementInput from '~/components/panels/formulate/products/components/AgreementInput.vue';
import CookieError from '~/components/panels/formulate/products/components/CookieError.vue';

export default {
	components: { AgreementInput, ProductsComponent, CookieError },
	mixins: [formulateFormScenario],
};
</script>

<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.formulate-form, .custom-control-label, .formulate-input, .formulate-input .formulate-input-label {
    font-family: $font-family-base !important;
		font-weight: 500 !important;
}

.field-required {
	&.formulate-input[data-classification='text'] input {
		border: 1px solid red !important;
	}
}

.custom-switch {
	line-height: 1.8;
}
.alert-primary {
	color: $white;
	background-color: $link-color;
	border-color: $link-color;
}

.close_link {
	display: flex;
	align-items: center;
	justify-content: space-between;
	line-height: 1;
	padding: 0;
	border: 0;
	background: transparent;
	outline: 0;
	cursor: pointer;

	&::after {
		position: relative;
		content: "\e915";
		font-family: "sk_icons";
		line-height: 1;
		font-size: .8rem;
		margin-left: 0.5rem;
		padding: 4px;
		cursor: pointer;
	}
}

span {
	margin: 0;
	line-height: 1.3;

	&.price-muted {
		font-size: 1.5rem;
		text-decoration: line-through;
		color: $border-color;
	}
}

.end-price {
	background: #FFFFFF;
	.amount-wrapper {
		border-right: 1px dashed $border-color;
		height: 100%;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		padding-right: 30px;
	}
}

.amount {
	font-weight: bold;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
	@include media-breakpoint-up(sm) {
		justify-content: space-between;
		flex-direction: row;
		align-items: center;
	}
}

.total-price {
	padding: 1rem;
	border: 1px solid $border-color;
	display: flex;
	background-color: #455FED;
	color: #FFFFFF;
	flex-direction: column;
	justify-content: space-between;
	@include media-breakpoint-up(sm) {
		padding: 2rem 1.5rem;
	}

	.description-small {
		font-weight: 400;
		line-height: 20px;
		color: #9BA9F7;

	}

	.education {
		border-top: 1px solid #FFFFFF;
	}

	input {
		background-color: transparent;
		border: none;
		border-bottom: 1px solid $border-color;
		width: 100%;
		outline-style: none;

		&::placeholder {
			color: $border-color;
		}
	}

	.input_under_span {
		font-size: 0.8rem;
		line-height: 1.2;
		font-weight: normal;
	}

	.btn-outline-secondary {
		color: $border-color;
		border-color: $border-color;

		&:hover {
			color: $white;
			border-color: $link-hover-color;
			background-color: $link-hover-color;
		}
	}

	.sum {
		margin: 2rem 0;
	}
}
.custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border: #FFFFFF;
}

.discount {
	.formulate-input-element {
		&.formulate-input-element--text {
			input {
				border: none !important;
				border-bottom: 1px solid black !important;
				padding-left: 0px !important;
				padding-bottom: 1rem !important;

				&::placeholder {
					color: black !important;
				}
			}
		}
		&.formulate-input-element--submit {
			button {
				font-weight: 400 !important;
			}
		}

	}
}
</style>
